module.exports = __webpack_public_path__ + "img/A.a4a1e740.png";